module.exports = __webpack_public_path__ + "static/media/pr-requests-for-landing.52f4885c.svg";